import { motion } from "framer-motion";
import { Repeat, Hourglass, MessageCircle } from "lucide-react";

const blocks = [
  {
    icon: Repeat,
    title: "Il pilota automatico",
    body: "Reagisci a schemi che non hai scelto. Le stesse situazioni, le stesse risposte, gli stessi risultati. Ti senti bloccato senza capire perché.",
  },
  {
    icon: Hourglass,
    title: "Il perfezionismo immobile",
    body: "Aspetti il momento perfetto, il piano perfetto, la certezza perfetta. E intanto non parti. L'analisi infinita diventa una gabbia.",
  },
  {
    icon: MessageCircle,
    title: "Lo stress e il dialogo interno",
    body: "Una voce che giudica, anticipa il fallimento e consuma energie. Sotto pressione sabota le tue decisioni — e nessuno la sente tranne te.",
  },
];

export default function IlProblema() {
  return (
    <section
      id="problema"
      className="relative bg-background py-28 md:py-40 border-t border-white/10"
      data-testid="problema-section"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="mb-16 md:mb-24 max-w-3xl">
          <div className="flex items-center gap-4 mb-6">
            <span className="h-px w-10 bg-primary" />
            <span className="text-[11px] tracking-[0.35em] text-primary">
              LA RESISTENZA INCONSCIA
            </span>
          </div>
          <h2 className="font-serif font-light text-4xl md:text-5xl text-foreground leading-tight">
            La resistenza non è pigrizia. È inconscia.
          </h2>
          <p className="mt-6 text-muted-foreground max-w-xl leading-relaxed">
            Non ti manca la volontà. Ti mancano le chiavi per disattivare i
            meccanismi che, in automatico, ti tengono fermo. Riconoscerli è il
            primo passo per superarli.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {blocks.map((b, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
              className="rounded-2xl border border-white/10 bg-card p-8 md:p-10 min-h-[300px] flex flex-col"
              data-testid={`problema-block-${i}`}
            >
              <b.icon className="text-primary mb-6" size={28} strokeWidth={1.3} />
              <h3 className="font-serif text-2xl text-foreground mb-3">
                {b.title}
              </h3>
              <p className="text-sm text-muted-foreground leading-relaxed">
                {b.body}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
